import {DELETED_RESOURCE_RETENTION_DAYS} from "config/constants";

// Server system setting defaults and parsing rules.

export const CONFIG_SYSTEM_DEFAULTS = {
    SYSTEM_UNLIMIT_ID: "intosoft",
    SYSTEM_ADMIN_ID: "admin",
    SYSTEM_RESOURCE_PATH: "",

    SYSTEM_FILE_UPLOAD_SIZE: 30,
    SYSTEM_CHECK_MAGIC_NUMBER_ENABLE: false,

    DOCUMENT_AUTO_COMPLETE_ENABLE: true,
    DOCUMENT_AUTO_COMPLETE_DELAY_DAYS: 7,

    SEAL_IMAGE_MAX_SIZE: 10,
    SEAL_IMAGE_FORMATS: "png|jpg|jpeg",

    DELETED_RESOURCE_RETENTION_DAYS,
};

export const CONFIG_SYSTEM_KEYS = Object.keys(CONFIG_SYSTEM_DEFAULTS);

export const CONFIG_SYSTEM_NUMBER_KEYS = [
    "SYSTEM_FILE_UPLOAD_SIZE",
    "DOCUMENT_AUTO_COMPLETE_DELAY_DAYS",
    "SEAL_IMAGE_MAX_SIZE",
    "DELETED_RESOURCE_RETENTION_DAYS",
];
